import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "subway"
const SubwayIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M9 14.625C9.828 14.625 10.5 15.297 10.5 16.125H8.25V14.625zM15.75 16.125H13.5C13.5 15.297 14.172 14.625 15 14.625H15.75z" />
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12V22.5H1.5V12C1.5 6.201 6.201 1.5 12 1.5M12 3C7.03 3 3 7.03 3 12V21H4.577L7.017 18.688C6.65 18.54 6.356 18.392 6.125 18.256 5.492 17.884 5.25 17.214 5.25 16.629V8.625C5.25 7.383 6.255 6.375 7.499 6.375H16.502C17.745 6.375 18.75 7.383 18.75 8.625V16.629C18.75 17.214 18.508 17.884 17.875 18.256 17.646 18.392 17.35 18.54 16.984 18.688L19.423 21H21V12C21 7.03 16.97 3 12 3M15.325 19.182C14.438 19.37 13.34 19.5 12 19.5S9.561 19.37 8.675 19.182L6.757 21H17.243zM6.75 16.63C6.75 16.839 6.832 16.932 6.885 16.963 7.51 17.33 9.05 18 12 18S16.489 17.331 17.115 16.963C17.168 16.932 17.25 16.84 17.25 16.629V13.5H6.75zM7.499 7.875C7.085 7.875 6.75 8.21 6.75 8.625V12H11.25V7.875zM12.75 12H17.25V8.625C17.25 8.21 16.915 7.875 16.502 7.875H12.75z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default SubwayIcon
